/**
 * mckinsey_consulting.js — McKinsey Consultant
 * ─────────────────────────────────────────────────────────────────────────────
 * Design Philosophy:
 *   Goal:         Corporate prestige, extreme editorial polish, impact-first
 *   Hierarchy:    Summary → Experience → Education → Skills
 *   Divider:      Dots — elegant dotted divider lines representing executive report styles
 *   Density:      Spacious — 28px margins, generous whitespace to project confidence
 *   Typography:   Prestigous serif (Georgia/Garamond) for headers, clean sans-serif (Arial)
 *                 for high-readability body copy
 *   Audience:     Management Consultants, Investment Bankers, Corporate Strategists, MBAs
 *
 * Visual Signature:
 *   - Airy, balanced single-column layout with lots of breathing room
 *   - Bold action-driven bullets (experience-impact)
 *   - Elegant serif headers with clean dotted rules to separate sections
 *   - Slate/Navy classic prestige coloring
 */

export const mckinsey_consulting = {
  id: 'product-consulting',
  version: 3,
  renderer: 'enterprise',
  name: 'McKinsey Consultant',
  layout: 'single-column',
  theme: 'classic-navy',
  density: 'comfortable',
  sectionDividerStyle: 'dots',
  sectionOrder: ['personal-info', 'summary', 'experience', 'education', 'skills', 'certifications'],
  components: {
    header: 'header-split',
    experience: 'experience-impact',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-classic',
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'education', 'skills', 'certifications'],
      },
      overrides: {
        '--font-family-primary': '"Georgia", "Garamond", "Times New Roman", serif',
        '--font-family-secondary': '"Arial", "Calibri", "Helvetica Neue", sans-serif',
        '--color-primary': '#1E3A5F', // McKinsey Slate Blue
        '--color-secondary': '#334155', // Charcoal Secondary
        '--color-accent': '#475569',
        '--color-text-main': '#1C1D1F',
        '--color-text-light': '#5E6166',
        '--color-border': '#CBD5E1',
        '--color-bg-page': '#FCFCFB', // Premium warm paper white
        '--spacing-margin': '28px',
        '--spacing-section-mb': '18px',
        '--spacing-item-mb': '12px',
        '--spacing-bullet-gap': '4px',
      },
    },
  },
  styleOverrides: {
    '--font-size-display': '24pt',
    '--weight-display': '700',
    '--heading-weight': '700',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--border-thickness-heading': '0',
    '--bullet-style': 'square',
    '--font-size-heading': '9.5pt',
    '--font-size-body': '9.5pt',
    '--font-size-bullet': '9.2pt',
    '--line-height-body': '1.55',
  },
};

export default mckinsey_consulting;
